
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33","height":"33"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"width":"33","height":"33","transform":"translate(0 .5)","fill":"#fff","stroke":"#707070"}})])]),_c('g',{attrs:{"transform":"translate(0 -.5)","clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M28.827 12.647a2.951 2.951 0 10-.635-.941 3.014 3.014 0 00.635.941zm-.865 2.739v8.9h1.483a8.438 8.438 0 001.517-.144 4.73 4.73 0 001.437-.5 3.2 3.2 0 001.071-.945 2.45 2.45 0 00.425-1.478v-5.833zm-4.806-3.731a2.869 2.869 0 001.147-.231 2.958 2.958 0 000-5.449 2.871 2.871 0 00-1.149-.231 2.831 2.831 0 00-1.14.231c-.269.115-.353.265-.723.445v4.566c.371.182.455.33.723.445a2.828 2.828 0 001.145.231zm-1.868 14.984c.371.08.5.143.768.179a6.308 6.308 0 00.87.064 6.574 6.574 0 001.337-.144 3.95 3.95 0 001.268-.495 2.911 2.911 0 00.945-.938 2.7 2.7 0 00.373-1.474v-10.3h-5.561v13.108zM.895 29.477l19.28 3.337V.186L.895 3.523z","fill":"#5558af"}}),_c('path',{attrs:{"d":"M14.984 10.197l-8.9.542v2.052l3.337-.134v9.516l2.224.13v-9.734l3.337-.148z","fill":"#fff"}})])])
          )
        }
      }
    